<template>
  <div id="suppliers" class="px-4">
    <supplier-list />
  </div>
</template>
<script>
import SupplierList from "@/components/supplier_management/SupplierList.vue";
export default {
  components: {
    SupplierList
  }
};
</script>
